module.exports = __webpack_public_path__ + "img/Viola-Mobile-logo-small.0620bb92.svg";